export default __webpack_public_path__ + "static/media/Bracers of the Grand Monarch.81102487.jpg";